import React, { useRef } from 'react';
import '../styles/BookAppointmentSection.css';
import emailjs from '@emailjs/browser';

const reasons = [
  {
    icon: (
      <svg width="36" height="36" aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="#1F3557" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"/><path d="M9 12l2 2 4-4"/></svg>
    ),
    title: "Insured Electricians",
  },
  {
    icon: (
      <svg width="36" height="36" aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="#1F3557" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="8" r="4"/><path d="M6.5 21h11M12 13v8"/></svg>
    ),
    title: "Licensed Experts",
  },
  {
    icon: (
      <svg width="36" height="36" aria-hidden="true" viewBox="0 0 24 24" fill="none" stroke="#1F3557" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="2" y="8" width="20" height="8" rx="3"/><path d="M6 12h.01M8 12h.01M10 12h.01"/></svg>
    ),
    title: "Affordable Price",
  }
];

const BookAppointmentSection = () => {
  const formRef = useRef();

  const sendEmail = (e) => {
    e.preventDefault();

    emailjs.sendForm(
      'service_400wfya',
      'template_56bn4m9',
      formRef.current,
      'v4aVMss4HfBL-_7FT'
    ).then(() => {
      alert('Appointment request sent successfully!');
      formRef.current.reset();
    }, () => {
      alert('Failed to send appointment request, please try again.');
    });
  };

  return (
    <div className="book-section-bg">
      <div className="book-section-wrapper">
        <div className="book-section-left">
          <div className="book-section-label">
            <span className="lightning">⚡</span>
            BOOK A SERVICE
          </div>
          <h1 className="book-section-title">
            Great Reasons To Use<br />
            AGR Consultant & Engineers
          </h1>
          <div className="book-section-description">
            our team of seasoned electricians to deliver exceptional service. With years of experience and honed skills, we tackle every project with expertise and efficiency, ensuring top-notch results for your electrical needs.
          </div>
          <div className="book-section-reasons">
            {reasons.map(reason => (
              <div className="reason-block" key={reason.title}>
                <div className="reason-icon">{reason.icon}</div>
                <div className="reason-title">{reason.title}</div>
              </div>
            ))}
          </div>
        </div>
        <div className="book-section-right">
          <div className="book-form-title">Book Appointment</div>
          <form className="book-appointment-form" ref={formRef} onSubmit={sendEmail}>
            <div className="form-row">
              <input className="form-input" type="text" name="user_name" placeholder="Name" required />
              <input className="form-input" type="email" name="user_email" placeholder="Email" required />
            </div>
            <div className="form-row">
              <input className="form-input" type="text" name="user_phone" placeholder="Your Phone" required />
              <input className="form-input" type="date" name="appointment_date" placeholder="Select Date" required />
            </div>
            <select className="form-input" name="service" defaultValue="" required>
              <option value="" disabled>Select Service</option>
              <option>Installation</option>
              <option>Repair</option>
              <option>Maintenance</option>
            </select>
            <textarea className="form-input form-textarea" name="message" placeholder="Message"></textarea>
            <input type="hidden" name="subject" value="Appointment booked from Web-Site" />
            <button className="form-button" type="submit">MAKE APPOINTMENT</button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default BookAppointmentSection;